import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Table,
  Segment,
  Input,
  Button,
  Loader,
  Message,
  Image,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { S3_BASE_URL } from "../../config/API";
import { debounce } from "lodash";

const ManufactureVariants = ({ loading, mvData, onScrollEnd, hasMore, fetchData ,search ,setSearch}) => {
 

  // Debounced search
/*   const debouncedSearch = useCallback(
    debounce((val) => {
      setSearch(val);
      fetchData(1, 50, false, val); // fetch new data with search
    }, 300),
    [fetchData]
  ); */

  const handleSearchChange1 = (e) => {
    debouncedSearch(e.target.value);
  };

  // No debounce — search updates instantly
const handleSearchChange = (e) => {
  const val = e.target.value;
  setSearch(val); 

  fetchData(1, 50, false, val); // fetch immediately
};

  return (
    <Grid centered padded style={{ marginTop: "0px", padding: "5vh" }}>
      <Helmet>
        <title>Products Listing</title>
      </Helmet>

      {/* Header */}
      <Grid.Row centered>
        <Grid.Column width={8} textAlign="center">
          <h2
            style={{
              fontWeight: 500,
              borderBottom: "2px solid #2185d0",
              color: "#2185d0",
              padding: "0.5em 0",
              marginBottom: "1em",
            }}
          >
            Products Listing
          </h2>
        </Grid.Column>
      </Grid.Row>

      {/* Search + More Actions */}
      <Grid.Row columns={2} centered style={{ marginBottom: "1em" }}>
        <Grid.Column width={4}>
          <Input
            fluid
            icon="search"
            placeholder="Search by ID or name..."
            value={search}
            onChange={handleSearchChange}
          />
        </Grid.Column>
        <Grid.Column width={3} textAlign="center">
          <Link to="/products/actions">
            <Button color="blue">More Actions</Button>
          </Link>
        </Grid.Column>
      </Grid.Row>

      {/* Scrollable Table */}
      <Grid.Row centered>
        <Grid.Column width={14}>
          <div
            style={{
              height: "70vh",
              overflow: "auto",
              border: "1px solid #ddd",
              borderRadius: "6px",
              padding: "0.5em",
            }}
            onScroll={onScrollEnd}
          >
            {mvData && mvData.length > 0 ? (
              <Table celled striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Id</Table.HeaderCell>
                    <Table.HeaderCell>Meal Type</Table.HeaderCell>
                    <Table.HeaderCell>Vendor</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Vendor Price</Table.HeaderCell>
                    <Table.HeaderCell>MRP</Table.HeaderCell>
                    <Table.HeaderCell>Offer Price</Table.HeaderCell>
                    <Table.HeaderCell>Active</Table.HeaderCell>
                    <Table.HeaderCell>Image</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {mvData.map((el) => (
                    <Table.Row key={el.id} negative={el.is_active !== 1}>
                      <Table.Cell>
                        <Link
                          to={`/products/${el.id}/vendingmachines`}
                          style={{ textDecoration: "underline", color: "#2185d0" }}
                        >
                          {el.id}
                        </Link>
                      </Table.Cell>
                      <Table.Cell>{el.meal_type}</Table.Cell>
                      <Table.Cell>{el.manufacturer_name}</Table.Cell>
                      <Table.Cell>
                        <Link
                          to={`/products/${el.id}/vendingmachines`}
                          style={{ textDecoration: "underline", color: "#2185d0" }}
                        >
                          {el.variant_name}
                        </Link>
                      </Table.Cell>
                      <Table.Cell>₹{el.vendor_price}</Table.Cell>
                      <Table.Cell>₹{el.mrp}</Table.Cell>
                      <Table.Cell>₹{el.offer_price}</Table.Cell>
                      <Table.Cell>{el.is_active ? "Yes" : "No"}</Table.Cell>
                      <Table.Cell>
                        {el.image_id ? (
                          <Image
                            src={`${S3_BASE_URL}/${el.image_id}`}
                            style={{
                              height: "80px",
                              width: "150px",
                              objectFit: "cover",
                              backgroundColor: "#f9f9f9",
                            }}
                          />
                        ) : (
                          "N/A"
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            ) : (
              <Message info header="No Products Found" content="Try adjusting your search or filters." />
            )}

            {/* Infinite Scroll Footer */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "1em",
              }}
            >
              {loading ? (
                <Loader active inline="centered" content="Loading more products..." />
              ) : !hasMore ? (
                <Message compact positive content="✅ No more products to load" />
              ) : null}
            </div>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ManufactureVariants;



// WEBPACK FOOTER //
// ./src/Modules/ManufactureVariants/component.jsx